// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-37f6bc4a] .el-dialogOrderChangePopup {\n  margin-top: 10vh !important;\n}\n", ""]);
// Exports
module.exports = exports;
